import { Record } from 'immutable'
import { CommissionSplit, ICommissionSplit } from './CommissionSplit'
import { IPrice, Price } from './Price'

export interface IListingSaleData {
  readonly askingPrice: IPrice
  readonly capRate: number
  readonly commissionSplit: ICommissionSplit
}

const ListingSaleDataRecord = Record({
  askingPrice: new Price(),
  capRate: 0,
  commissionSplit: new CommissionSplit(),
})

export class ListingSaleData extends ListingSaleDataRecord
  implements IListingSaleData {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new ListingSaleData()
    }

    const { askingPrice, commissionSplit, ...rest } = initialState

    return new ListingSaleData({
      askingPrice: Price.fromJS(askingPrice),
      commissionSplit: CommissionSplit.fromJS(commissionSplit),
      ...rest,
    })
  }

  public readonly askingPrice: Price
  public readonly capRate: number
  public readonly commissionSplit: CommissionSplit

  constructor(props?: Partial<ListingSaleData>) {
    props ? super(props) : super()
  }
}
